import { css } from '@emotion/core'
import { Arrow } from '@fs/zion-icon'
import { Button } from '@fs/zion-ui'
import React from 'react'

const actionButton = css`
  text-align: center;
  padding: 8px 0px;
`

const hide = css`
  visibility: hidden;
`

export default function ActionButton({ type, onClick }) {
  if (type === 'NONE') {
    return null
  }
  return (
    <div css={type === 'HIDDEN' && hide} data-testid="actionButtonContainer">
      <div css={actionButton}>
        <Button Icon={Arrow} iconDirection={type === 'REPLACE' ? 'forward' : 'backward'} onClick={onClick}>
          {type}
        </Button>
      </div>
    </div>
  )
}
